export default __webpack_public_path__ + "static/media/Via_Vorderseite_12.45208523.jpg";